import { render, staticRenderFns } from "./PartNumberList.vue?vue&type=template&id=2b37176c"
import script from "./PartNumberList.vue?vue&type=script&lang=js"
export * from "./PartNumberList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports